//AUTH
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_CLEAR_ERROR = 'LOGIN_CLEAR_ERROR';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const RESET_APP = 'RESET_APP';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUEST_SUCCESS = 'LOGOUT_REQUEST_SUCCESS';

// JOB
export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
export const CREATE_JOB_REQUEST_SUCCESS = 'CREATE_JOB_REQUEST_SUCCESS';
export const GET_JOB_REQUEST = 'GET_JOB_REQUEST';
export const GET_JOB_REQUEST_SUCCESS = 'GET_JOB_REQUEST_SUCCESS';
export const GET_ALL_JOB_REQUEST = 'GET_ALL_JOB_REQUEST';
export const GET_ALL_JOB_REQUEST_SUCCESS = 'GET_ALL_JOB_REQUEST_SUCCESS';
export const UPDATE_JOB_REQUEST = 'UPDATE_JOB_REQUEST';
export const UPDATE_JOB_REQUEST_SUCCESS = 'UPDATE_JOB_REQUEST_SUCCESS';
export const UPDATE_JOB_STATUS_REQUEST = 'UPDATE_JOB_STATUS_REQUEST';
export const UPDATE_JOB_STATUS_REQUEST_SUCCESS = 'UPDATE_JOB_STATUS_REQUEST_SUCCESS';
export const DELETE_JOB_REQUEST = 'DELETE_JOB_REQUEST';
export const DELETE_JOB_REQUEST_SUCCESS = 'DELETE_JOB_REQUEST_SUCCESS';

// BARCODE
export const CREATE_BARCODE_REQUEST = 'CREATE_BARCODE_REQUEST';
export const CREATE_BARCODE_REQUEST_SUCCESS = 'CREATE_BARCODE_REQUEST_SUCCESS';
export const GET_BARCODE_REQUEST = 'GET_BARCODE_REQUEST';
export const GET_BARCODE_REQUEST_SUCCESS = 'GET_BARCODE_REQUEST_SUCCESS';
export const GET_ALL_BARCODE_REQUEST = 'GET_ALL_BARCODE_REQUEST';
export const GET_ALL_BARCODE_REQUEST_SUCCESS = 'GET_ALL_BARCODE_REQUEST_SUCCESS';
export const UPDATE_BARCODE_REQUEST = 'UPDATE_BARCODE_REQUEST';
export const UPDATE_BARCODE_REQUEST_SUCCESS = 'UPDATE_BARCODE_REQUEST_SUCCESS';
export const UPDATE_BARCODE_STATUS_REQUEST = 'UPDATE_BARCODE_STATUS_REQUEST';
export const UPDATE_BARCODE_STATUS_REQUEST_SUCCESS = 'UPDATE_BARCODE_STATUS_REQUEST_SUCCESS';
export const DELETE_BARCODE_REQUEST = 'DELETE_BARCODE_REQUEST';
export const DELETE_BARCODE_REQUEST_SUCCESS = 'DELETE_BARCODE_REQUEST_SUCCESS';

// DASHBOARD
export const DASHBOARD_STATS_REQUEST = 'DASHBOARD_STATS_REQUEST';
export const DASHBOARD_STATS_REQUEST_SUCCESS = 'DASHBOARD_STATS_REQUEST_SUCCESS';

// INVOICE
export const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
export const CREATE_INVOICE_REQUEST_SUCCESS = 'CREATE_INVOICE_REQUEST_SUCCESS';
export const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
export const UPDATE_INVOICE_REQUEST_SUCCESS = 'UPDATE_INVOICE_REQUEST_SUCCESS';
export const GET_INVOICE_REQUEST = 'GET_INVOICE_REQUEST';
export const GET_INVOICE_REQUEST_SUCCESS = 'GET_INVOICE_REQUEST_SUCCESS';

// EXPENSES
export const CREATE_EXPENSES_REQUEST = 'CREATE_EXPENSES_REQUEST';
export const CREATE_EXPENSES_REQUEST_SUCCESS = 'CREATE_EXPENSES_REQUEST_SUCCESS';
export const UPDATE_EXPENSES_REQUEST = 'UPDATE_EXPENSES_REQUEST';
export const UPDATE_EXPENSES_REQUEST_SUCCESS = 'UPDATE_EXPENSES_REQUEST_SUCCESS';
export const GET_EXPENSES_REQUEST = 'GET_EXPENSES_REQUEST';
export const GET_EXPENSES_REQUEST_SUCCESS = 'GET_EXPENSES_REQUEST_SUCCESS';
